import React from "react";
import Icons from "./Icons";
import RangeInput from "../../../Layout/Inputs/RangeInput/";
import "./TransformText.css";

class TransformText extends React.Component {
  render() {
    const handleUpdateTransformType = (transformType) => {
      this.props.onUpdateTransformType(transformType);
    };

    const handleTransformAmount = (event) => {
      this.props.onUpdateTransformAmount(event.target.value);
    };

    const handleClearTransform = () => {
      this.props.onUpdateTransformAmount(45);
      this.props.onUpdateTransformType("");
    };

    return (
      <div className={`tool__textfield tool--transform`}>
        <h4 className="">Transform Text</h4>
        <Icons
          transformType={this.props.transformType}
          handleUpdateTransformType={handleUpdateTransformType}
        />

        <RangeInput
          min="0"
          max="100"
          value={this.props.transformAmount}
          handleOnChange={handleTransformAmount}
        />

        <a className="transform__clear" onClick={handleClearTransform}>
          Clear transform
        </a>
      </div>
    );
  }
}

export default TransformText;
